<template>
    <div class="menu">
        <navTop :isLogin="0"></navTop>
        <div class="menu_sign">
            <div class="sign_title">电子签章在线签署</div>
            <div class="sign_tetal">
                <div class="seal shape" @click="$router.push('sealList')">
                    <img src="../../../../static/img/nav-2.png"/>
                </div>
                <div class="contract shape" @click="$router.push('contractSin')">
                    <img src="../../../../static/img/nav-3.png"/>
                </div>
<!--                <div class="sign shape" @click="isLogin ? $router.push('signInsp') : $router.push('youKe')">-->
<!--                    <img src="../../../../static/img/nav-4.png"/>-->
<!--                </div>-->
                <div class="sign shape" @click="$router.push('youKe')">
                  <img src="../../../../static/img/nav-4.png"/>
                </div>
            </div>
        </div>
        <div class="menu_contract">
            <div class="contract_title">合同签署、管理 更高效安全</div>
            <div class="contract_list">
                <div class="contract_for" v-for="(item,index) in contractList" :key="index">
                    <div class="contract_top">
                        <img :src="item.url"/>
                    </div>
                    <div class="contract_cent">
                        {{item.title}}
                    </div>
                    <div class="contract_bom">
                        {{item.detal}}
                    </div>
                </div>
            </div>
            <div class="contract_btn">
                <div class="btn" @click="open()">免费试用</div>
            </div>
        </div>
        <div class="menu_why">
            <div class="why_title">为什么选择四川相君电子签名产品</div>
            <div class="why_mess">
                <div class="mess_all">
                    <div class="mess_left">
                        <div class="actig" @mouseover="yi.yiRu1 = 1" @mouseleave="yi.yiRu1 = 0">
                            <div class="act_left">
                                <img src="../../../../static/img/why-1-1.png" v-show="yi.yiRu1 == 1"/>
                                <img src="../../../../static/img/why-1.png" v-show="yi.yiRu1 == 0"/>
                            </div>
                            <div class="act_right">
                                <div class="title">签章申请简便安全放心</div>
                                <div class="message">
                                    涵盖智能档案、智能模板、智能起草、智能收发、智能签署、智能审批、智能管理、合规管理、权限管理等合同管理的所有环节让企业管理如臂使指。
                                </div>
                            </div>
                        </div>
                        <div class="actig" @mouseover="yi.yiRu2 = 1" @mouseleave="yi.yiRu2 = 0">
                            <div class="act_left">
                                <img src="../../../../static/img/why-3-3.png" v-show="yi.yiRu2 == 1"/>
                                <img src="../../../../static/img/why-3.png" v-show="yi.yiRu2 == 0"/>
                            </div>
                            <div class="act_right">
                                <div class="title">签署文件安全有保障</div>
                                <div class="message">
                                    7大全球顶级安全资质认证、6大全球领先安全科技，世界500强、大型银行广泛使用，系统可用性不低于99.99%。超过1900天的安全运行记录。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mess_cent">
                        <div class="centerAll">
                            <div class="cent-text1">四川相君</div>
                            <div class="cent-text2" @click="open()">免费试用</div>
                        </div>
                    </div>
                    <div class="mess_right">
                        <div class="actig" @mouseover="yi.yiRu3 = 1" @mouseleave="yi.yiRu3 = 0">
                            <div class="act_left">
                                <img src="../../../../static/img/why-2.png" v-show="yi.yiRu3 == 1"/>
                                <img src="../../../../static/img/why-2-2.png" v-show="yi.yiRu3 == 0"/>
                            </div>
                            <div class="act_right">
                                <div class="title">签署文件智能化管理</div>
                                <div class="message">
                                    提供全周期实时公证、多通道存证、在线裁决、区块链追溯、合同AI分析、合同AI智能检索等服务，多次得到司法机构事实认证，提升企业维权效率。
                                </div>
                            </div>
                        </div>
                        <div class="actig" @mouseover="yi.yiRu4 = 1" @mouseleave="yi.yiRu4 = 0">
                            <div class="act_left">
                                <img src="../../../../static/img/why-4-4.png" v-show="yi.yiRu4 == 1"/>
                                <img src="../../../../static/img/why-4.png" v-show="yi.yiRu4 == 0"/>
                            </div>
                            <div class="act_right">
                                <div class="title">终身服务团队 实时解决客户问题</div>
                                <div class="message">
                                    支持公有云部署、文档本地化部署，标准化产品最快可做到7天交付。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="menu_news" id="news">
            <div class="news_all">
                <div class="news_title">新闻资讯</div>
                <div class="news_for" v-for="(item,index) in newsList" :key="index">
                    <div class="for_img">
                        <img :src="'http://47.108.75.235:5389//CM-API' + item.icon"/>
                        <!-- <img src=".。" /> -->
                    </div>
                    <div class="for_mess">
                        <div class="for_text" v-for="(newItem,newIndex) in item.secondList" :key="newIndex"
                             v-show="newIndex <= 4">
                            <div @click="handlNewDetal(item.newsModuleId,newItem.id,item.secondList)"
                                 style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                <span>{{newItem.ct.substring(0,10)}}</span>
                                {{newItem.title}}

                            </div>
                        </div>
                    </div>
                </div>
                <div class="news_btn">
                    <div class="btn" @click="handlNewMore">查看更多</div>
                </div>
            </div>
        </div>

        <div class="menu_sure">
            <div class="sure_title">客户的肯定</div>
            <div class="sure_banner">
                <div class="swiperOne">
                    <img :src="swiperBanner[zero].url"/>
                </div>
                <div class="swiperTwo">
                    <img :src="swiperBanner[one].url"/>
                </div>
                <div class="swiperThree">
                    <img :src="swiperBanner[two].url"/>
                </div>
                <div class="swiperFour">
                    <img :src="swiperBanner[three].url"/>
                </div>
                <div class="swiperFive">
                    <img :src="swiperBanner[four].url"/>
                </div>
                <div class="left" @click="handlLeft">
                    <img src="../../../../static/img/left.png"/>
                </div>
                <div class="right" @click="handlRight">
                    <img src="../../../../static/img/right.png"/>
                </div>

            </div>
            <div class="sure_user">
                <div class="text1">冯雷</div>
                <div class="text2">路歌 创始人、董事长&CEO</div>
                <div class="text3">上上签的电子合同严谨合规，在降本增效的同时也能给客户更强的法律保障。
                    通过使用上上签的电子合同服务，路歌物流平台进一步提升了业务推进效率，迅速与货源企业、物流公司、
                    卡车司机等上下游各方建立合作。上上签的合同安全性、法律严谨性也让路歌非常放心。
                </div>
            </div>
        </div>

        <div class="menu_select">
            <div class="select_title">848万+标杆企业选择我们</div>
            <div class="select_mess"  v-if="selectList.length>0"  >
                <div class="select_banner">
                    <div class="select_list" v-for="(item,index) in selectList" :key="index"
                         @click="selectActive = index">
                        {{item.name}}
                        <div class="select_line" v-show="selectActive == index"></div>
                    </div>
                </div>
                <div class="select_listImg">
                    <div class="img_for" v-for="(item,newIndex) in selectList[selectActive].picPath" :key="newIndex">
                        <img :src="$global.Local + item"/>
                    </div>
                </div>
                <div class="select_btn">
                    <div class="btn" @click="handlAnLi">查看更多</div>
                </div>
            </div>
        </div>

        <div class="menu_more">
            <div class="more_title">让更多的人用四川相君签合同</div>
            <div class="more_btn">
                <div class="left" @click="open()">注册有礼</div>
                <div class="right" @click="open()">免费试用</div>
            </div>
            <div class="more_assake">
                <div class="left">
                    <div class="num">13,495,514,215<span>次</span></div>
                    <div class="detal">18年间，累计合同签署量超134亿次</div>
                </div>
                <div class="left">
                    <div class="num">13,495,514,215<span>次</span></div>
                    <div class="detal">18年间，累计合同签署量超134亿次</div>
                </div>
                <div class="left">
                    <div class="num">13,495,514,215<span>次</span></div>
                    <div class="detal">18年间，累计合同签署量超134亿次</div>
                </div>
            </div>
            <div class="more_bom">
                <div class="text">专业咨询顾问，为您提供1对1专属服务</div>
                <div class="btn" @click="open()">免费试用</div>
            </div>
        </div>
        <navAdv/>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'
    import navAdv from '../../nav/nav-adv.vue'  
    export default {
        components: {
            navTop,
            navBom,
            navAdv
        },

        data() {
            return {
                isLogin: 0,
                zero: 0,
                one: 1,
                two: 2,
                three: 3,
                four: 4,
                swiperBanner: [{
                    url: require('../../../../static/img/banner-1.png')
                },
                    {
                        url: require('../../../../static/img/banner-2.png')
                    },
                    {
                        url: require('../../../../static/img/banner-3.png')
                    },
                    {
                        url: require('../../../../static/img/banner-4.png')
                    },
                    {
                        url: require('../../../../static/img/banner-5.png')
                    },
                ],
                swiperList: [{
                    url: require('../../../../static/img/test-logo.png'),
                },
                    {
                        url: require('../../../../static/img/test-logo.png'),
                    },
                    {
                        url: require('../../../../static/img/test-logo.png'),
                    },
                    {
                        url: require('../../../../static/img/test-logo.png'),
                    },
                    {
                        url: require('../../../../static/img/test-logo.png'),
                    },
                    {
                        url: require('../../../../static/img/test-logo.png'),
                    },
                ],
                selectActive: 0,
                selectList: [],
                newsList: [],
                contractList: [{
                    id: 0,
                    url: require('../../../../static/img/con-1.png'),
                    title: '快捷方便',
                    detal: '一键签章，一键验章，生效仅需几秒随时随地进行签署，一键搞定'
                },
                    {
                        id: 1,
                        url: require('../../../../static/img/con-2.png'),
                        title: '节约资源',
                        detal: '无纸化环保，在线签署无需快递签署文件，节约成本'
                    },
                    {
                        id: 2,
                        url: require('../../../../static/img/con-3.png'),
                        title: '合同管理',
                        detal: '合同状态管理、导出下载、统计报表等功能'
                    },
                    {
                        id: 3,
                        url: require('../../../../static/img/con-4.png'),
                        title: '签验管理',
                        detal: '多样化签章，支持手写签章、行政签章；签章分类、新增、删除等功能'
                    },
                    {
                        id: 4,
                        url: require('../../../../static/img/con-5.png'),
                        title: '合规管理',
                        detal: '在线实名认证，意愿签验、时间防篡改等基础上，通过再次验证等功能，加强签署流程合规'
                    },
                    {
                        id: 5,
                        url: require('../../../../static/img/con-6.png'),
                        title: '合法安全',
                        detal: '使用公安机关备案印模、国家密码局权威认证（密钥+密码）双重验证，签署文件不可篡改'
                    },
                ],
                yi: {
                    yiRu1: 0,
                    yiRu2: 0,
                    yiRu3: 0,
                    yiRu4: 0,
                }
            }
        },
        created() {

            let _this = this;
            _this.isLogin = localStorage.getItem('login') ? localStorage.getItem('login') : 0;
            let param = new FormData();

            _this.newsList = [];
            _this.api.getNews(param).then(res => {
                res.data.forEach((item, index) => {
                    if (index <= 2) {
                        _this.newsList.push(item);
                    }
                })
                localStorage.setItem('newsList', JSON.stringify(_this.newsList));
                //
            })
            console.log(_this.newsList, '新闻')


            _this.api.getAdvertList(param).then(res => {
                console.log(res, "广告")
                res.data.forEach((item, index) => {
                    if (item.picPath != '') {
                        item.picPath = item.picPath.split(',')
                    } else {
                        item.picPath = item.picPath.split('')
                        console.log(item.picPath)
                    }
                })
                _this.selectList = res.data;
                localStorage.setItem('newsAnLi', JSON.stringify(_this.selectList));
            })


        },
        methods: {
            handlLeft() {
                if (this.zero == 4) {
                    this.zero = 0;
                } else {
                    this.zero += 1;
                }
                if (this.one == 4) {
                    this.one = 0;
                } else {
                    this.one += 1;
                }
                if (this.two == 4) {
                    this.two = 0;
                } else {
                    this.two += 1;
                }
                if (this.three == 4) {
                    this.three = 0;
                } else {
                    this.three += 1;
                }
                if (this.four == 4) {
                    this.four = 0;
                } else {
                    this.four += 1;
                }
            },
            handlRight() {
                if (this.zero == 0) {
                    this.zero = 4;
                } else {
                    this.zero -= 1;
                }
                if (this.one == 0) {
                    this.one = 4;
                } else {
                    this.one -= 1;
                }
                if (this.two == 0) {
                    this.two = 4;
                } else {
                    this.two -= 1;
                }
                if (this.three == 0) {
                    this.three = 4;
                } else {
                    this.three -= 1;
                }
                if (this.four == 0) {
                    this.four = 4;
                } else {
                    this.four -= 1;
                }
            },
            handlNewDetal(bigId, minId, listId) {
                let list = [];
                listId.forEach((item, index) => {
                    list.push(item.id)
                })
                this.$router.push({
                    name: 'newsDetal',
                    params: {
                        bigId: bigId,
                        minId: minId,
                        listId: list
                    }
                });
            },
            open() { //
                if (localStorage.getItem('login') == 1) {

                    this.$router.push('loginMenu');
                } else {
                    this.$confirm('免费试用需要先进行注册, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: '',
                        center: true
                    }).then(() => {
                        this.$router.push('loginRegist');
                    }).catch(() => {
                    });
                }

            },
            offset() {
                var PageId = document.querySelector('#news')
                // 打印出对应页面与窗口的距离
                console.log(PageId.offsetTop)
                window.scrollTo({
                    'top': PageId.offsetTop,
                    'behavior': 'smooth'
                })
            },
            handlNewMore() {
                this.$router.push('newsList');
            },
            handlAnLi() {
                this.$router.push({
                    name: 'anLi',
                    params: {
                        list: JSON.stringify(this.selectList)
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';
    // .el-carousel__item h3 {
    //   color: #475669;
    //   font-size: 14px;
    //   opacity: 0.75;
    //   line-height: 200px;
    //   margin: 0;
    // }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n+1) {
    //   background-color: #d3dce6;
    // }

    /deep/ .el-carousel__indicators--outside {
        display: none;
    }

    .swiperImg {
        width: @a;
        height: @a;
        object-fit: cover;
    }

    .menu {
        width: @a;
        height: @a;

        .menu_sign {
            width: @a;
            height: 460px;
            background-color: #f2f2f2;

            .sign_title {
                width: @a;
                height: 36px;
                font-family: MicrosoftYaHei;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                padding-top: 51px;
                text-align: center;
            }

            .sign_tetal {
                width: @a;
                height: calc(@a - 36px);
                @row();

                .shape {
                    width: 260px;
                    height: 280px;
                    cursor: pointer;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: cover;
                    }
                }


                .contract {
                    margin-left: 120px;
                }

                .sign {
                    margin-left: 120px;
                }

                .sign_text {
                    width: @a;
                    height: @a;
                    @column();
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #ffffff;

                    img {
                        width: 64px;
                        height: 73px;
                        margin-bottom: 24px;
                    }
                }
            }
        }

        .menu_contract {
            width: @a;
            height: 610px;
            background-color: #fff;

            .contract_title {
                padding-top: 50px;
                width: @a;
                height: 100px;
                font-family: MicrosoftYaHei;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: center;
            }

            .contract_list {
                width: @a;
                height: calc(100% - 200px);
                overflow: hidden;
                zoom: 1;
                padding: 10px 12%;

                .contract_for:hover {
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                }

                .contract_for {
                    width: calc(@a / 3.1);
                    height: 180px;
                    background-color: #ffffff;
                    float: left;
                    margin: 0.5%;
                    cursor: pointer;

                    .contract_top {
                        width: @a;
                        height: 30px;
                        margin-top: 42px;
                        text-align: center;

                        img {
                            width: 35px;
                            height: 30px;
                            object-fit: cover;
                        }
                    }

                    .contract_cent {
                        margin-top: 16px;
                        width: @a;
                        height: 18px;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        text-align: center;
                    }

                    .contract_bom {
                        margin-top: 15px;
                        width: @a;
                        padding: 0 10px;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        text-align: center;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }
            }

            .contract_btn {
                cursor: pointer;
                width: @a;
                height: 100px;
                @row();

                .btn {
                    width: 180px;
                    height: 50px;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                    border-radius: 25px;
                    text-align: center;
                    line-height: 50px;
                }
            }
        }

        .menu_why {
            width: @a;
            height: 510px;
            background-color: #f2f2f2;

            .why_title {
                width: @a;
                height: 100px;
                padding-top: 50px;
                text-align: center;
                font-family: MicrosoftYaHei;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .why_mess {
                width: @a;
                height: calc(@a - 100px);
                @row();

                .mess_all {
                    width: @a;
                    height: 320px;
                    display: flex;
                    justify-content: center;

                    .mess_left {
                        width: 480px;
                        height: @a;
                        display: @flex;
                        flex-direction: column;
                        justify-content: space-between;

                    }

                    .mess_cent {
                        width: 320px;
                        height: @a;
                        @row();

                        .centerAll {
                            width: 220px;
                            height: 220px;
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#ffffff,
                            #ffffff);
                            background-blend-mode: normal,
                            normal;
                            box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                            border-radius: 50%;
                            overflow: hidden;
                            @column();

                            .cent-text1 {
                                width: @a;
                                height: 39px;
                                font-family: ZhenyanGB-Regular;
                                font-size: 40px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 4px;
                                color: #ffffff;
                                text-align: center;
                            }

                            .cent-text2 {
                                width: 120px;
                                height: 40px;
                                background-color: #ffffff;
                                border-radius: 20px;
                                font-family: MicrosoftYaHei-Bold;
                                font-size: 18px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 0px;
                                color: #21a1db;
                                @row();
                                margin-top: 35px;
                                cursor: pointer;
                            }
                        }
                    }

                    .actig:hover {
                        width: 480px;
                        height: 110px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#ffffff,
                        #ffffff);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        border-radius: 50px;
                        border-radius: 50px;
                        display: flex;
                        align-items: center;
                        padding: 10px;
                        color: #fff;

                        .act_left {
                            background-color: #fff !important;
                            background-image: none;
                        }
                    }

                    .actig {
                        width: 480px;
                        height: 110px;
                        background-color: #ffffff;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                        border-radius: 50px;
                        display: flex;
                        align-items: center;
                        padding: 10px;
                        cursor: pointer;
                        color: #333333;

                        .act_left {
                            width: 90px;
                            height: 90px;
                            border-radius: 50px;
                            overflow: hidden;
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#ffffff,
                            #ffffff);
                            background-blend-mode: normal,
                            normal;
                            @row();

                            img {
                                width: 35px;
                                height: 35px;
                            }
                        }

                        .act_right {
                            width: calc(@a - 90px);
                            height: 90px;
                            display: @flex;
                            flex-direction: column;
                            justify-content: space-between;
                            padding-left: 10px;

                            .title {
                                width: @a;
                                height: 19px;
                                font-family: MicrosoftYaHei-Bold;
                                font-size: 18px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 0px;
                            }

                            .message {
                                width: @a;
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 0px;
                            }
                        }
                    }


                    .mess_right {
                        width: 480px;
                        height: @a;
                        display: @flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }
                }
            }
        }

        .menu_news {
            width: 100%;
            height: 650px;
            background-color: #fff;
            display: @flex;
            align-items: center;
            justify-content: center;
            padding-left: 13%;
            padding-right: 11%;

            .news_all {
                width: 1465px;
                height: 599px;
                overflow: hidden;
                zoom: 1;

                .news_title {
                    width: @a;
                    height: 90px;
                    font-family: MicrosoftYaHei;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: center;
                }

                .news_for:first-child {
                    margin: 0;
                }

                .news_for {
                    width: 30%;
                    height: auto;
                    float: left;
                    margin-left: 20px;

                    .for_img {
                        width: @a;
                        height: 210px;
                        border-radius: 10px;
                        overflow: hidden;

                        img {
                            width: @a;
                            height: @a;
                            // object-fit: cover;
                        }
                    }

                    .for_mess {
                        margin-top: 27px;
                        width: @a;
                        height: 200px;

                        .for_text {
                            margin-top: 10px;
                            font-family: MicrosoftYaHei;
                            font-size: 16px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 0px;
                            color: #333333;

                            cursor: pointer;

                            span {
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 0px;
                                color: #777777;
                                margin-right: 20px;
                            }
                        }

                    }
                }

                .news_btn {
                    width: @a;
                    height: 65px;
                    @row();
                    margin: 70px 0 20px 0;

                    .btn {
                        width: 180px;
                        height: 50px;
                        background-color: #ffffff;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                        border-radius: 25px;
                        color: #333333;
                        font-size: 24px;
                        line-height: 50px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
        }

        .menu_sure {
            width: @a;
            height: 580px;
            background-color: #f2f2f2;

            .sure_title {
                width: @a;
                height: 139px;
                @row();
                font-family: MicrosoftYaHei;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .sure_banner {
                width: @a;
                height: 201px;
                padding: 0 14%;
                // background-color: #808080;
                display: flex;
                justify-content: center;
                position: relative;
                align-items: center;

                .left:active {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#21a1db,
                    #21a1db);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                }

                .left {
                    width: 60px;
                    height: 60px;
                    background-color: #ffffff;
                    border-radius: 50px;
                    @row();
                    position: absolute;
                    left: 14%;
                    bottom: 70px;
                    cursor: pointer;

                    img {
                        width: 24px;
                        height: 18px;
                        object-fit: cover;
                    }
                }

                .right:active {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#21a1db,
                    #21a1db);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                }

                .right {
                    width: 60px;
                    height: 60px;
                    border-radius: 50px;
                    @row();
                    position: absolute;
                    right: 14%;
                    bottom: 70px;
                    cursor: pointer;
                    background-color: #ffffff;

                    img {
                        width: 24px;
                        height: 18px;
                        object-fit: cover;
                    }
                }

                .swiperOne {
                    width: 120px;
                    height: 120px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    overflow: hidden;

                    img {
                        width: @a;
                        height: @a;
                    }
                }

                .swiperTwo {
                    width: 140px;
                    height: 140px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-left: 70px;

                    img {
                        width: @a;
                        height: @a;
                    }
                }

                .swiperThree {
                    width: 200px;
                    height: 200px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-left: 80px;

                    img {
                        width: @a;
                        height: @a;
                    }
                }

                .swiperFour {
                    width: 140px;
                    height: 140px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-left: 81px;

                    img {
                        width: @a;
                        height: @a;
                    }
                }

                .swiperFive {
                    width: 120px;
                    height: 120px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-left: 51px;

                    img {
                        width: @a;
                        height: @a;
                    }
                }
            }

            .sure_user {
                width: @a;
                height: 150px;
                margin-top: 38px;
                @column();

                .text1 {
                    width: 80px;
                    height: 24px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333333;
                    text-align: center;
                }

                .text2 {
                    width: auto;
                    height: 19px;
                    font-family: MicrosoftYaHei;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333333;
                    margin-top: 20px;
                }

                .text3 {
                    width: 1000px;
                    height: 47px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 30px;
                    letter-spacing: 0px;
                    color: #777777;
                    margin-top: 39px;
                }
            }

        }

        .menu_select {
            width: @a;
            // height: 850px;
            height: auto;
            background-color: #f2f2f2;
            @column();

            .select_title {
                width: @a;
                height: 75px;
                font-family: MicrosoftYaHei;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: center;
                background-color: #f2f2f2;
            }

            .select_mess {
                width: 1450px;
                height: auto;

                .select_banner {
                    width: @a;
                    height: 80px;
                    display: flex;
                    justify-content: center;
                    border-bottom: solid 1px #808080;

                    .select_list {
                        width: 150px;
                        height: @a;
                        line-height: 80px;
                        text-align: center;
                        font-size: 25px;
                        color: #333333;
                        font-family: MicrosoftYaHei;
                        cursor: pointer;
                        position: relative;

                        .select_line {
                            width: 100px;
                            height: 3px;
                            background-color: red;
                            position: absolute;
                            left: 25px;
                            bottom: 0;
                        }
                    }

                }

                .select_listImg {
                    width: @a;
                    height: auto;
                    padding: 20px;
                    overflow: hidden;
                    zoom: 1;

                    .img_for {
                        border: solid 1px #808080;
                        width: 230px;
                        height: 100px;
                        margin: 2px;
                        float: left;
                        @row();

                        img {
                            width: 80%;
                            height: 80%;
                            object-fit: cover;
                        }
                    }
                }

                .select_btn {
                    width: @a;
                    height: 50px;
                    @row();
                    margin: 0 0 50px 0;

                    .btn {
                        width: 180px;
                        height: 50px;
                        background-color: #ffffff;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                        border-radius: 25px;
                        font-family: MicrosoftYaHei;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 0px;
                        color: #333333;
                        line-height: 50px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
        }

        .menu_more {
            width: @a;
            height: 580px;
            background-image: url(../../../../static/img/user_sure.png);
            background-size: 100%;
            @column();

            .more_title {
                width: 700px;
                height: 47px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 48px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #ffffff;
                margin-top: 90px;
            }

            .more_btn {
                width: 440px;
                height: 60px;
                display: flex;
                margin-top: 54px;

                .left {
                    width: 200px;
                    height: 60px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#21a1db,
                    #21a1db);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    border-radius: 5px;
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                    cursor: pointer;
                }

                .right {
                    width: 200px;
                    height: 60px;
                    background-color: #21a1db57;
                    border-radius: 5px;
                    border: solid 1px #ffffff;
                    margin-left: 40px;
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                    cursor: pointer;
                }
            }

            .more_assake {
                width: @a;
                height: 90px;
                margin-top: 58px;
                display: flex;
                justify-content: space-around;

                .left {
                    width: auto;
                    height: 90px;

                    .num {
                        width: auto;
                        height: 56px;
                        font-family: MicrosoftYaHei;
                        font-size: 60px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #ffffff;

                        span {
                            font-family: MicrosoftYaHei;
                            font-size: 30px;
                            font-weight: normal;
                            letter-spacing: 1px;
                            color: #ffffff;
                        }
                    }

                    .detal {
                        width: auto;
                        height: 18px;
                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 0px;
                        color: #ffffff;
                        margin-top: 14px;
                    }
                }
            }

            .more_bom {
                width: @a;
                height: 140px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%);
                opacity: 0.7;
                margin-top: 54px;
                @row();

                .text {
                    width: 650px;
                    height: 37px;
                    font-family: MicrosoftYaHei;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #ffffff;
                }

                .btn {
                    width: 180px;
                    height: 50px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#ffffff,
                    #ffffff);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    border-radius: 25px;
                    line-height: 50px;
                    text-align: center;
                    color: #fff;
                    margin-left: 58px;
                    cursor: pointer;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/menu/menu.vue